import { createEntitySlice } from "../firestoreModuleUtils/slice";
import { UserHistory } from "./records";

const slice = createEntitySlice<UserHistory>({ name: "userHistories" });

export const reducer = slice.reducer;
export const actions = slice.actions;
